import { Urls } from '@paragon/environment-tools';

let getCurrentUrls: () => Urls | undefined;
let getJwtToken: () => string | null;

export function injectDataConnectionsConfiguration(
  injectedGetCurrentUrls: () => Urls | undefined,
  injectedGetJwtTokenParam: () => string | null,
) {
  getCurrentUrls = injectedGetCurrentUrls;
  getJwtToken = injectedGetJwtTokenParam;
}

export function getCurrentJwtToken() {
  if (typeof getJwtToken !== 'function') {
    throw new Error('Data connection not initialized');
  }

  return getJwtToken();
}

export function getServerUrls() {
  if (typeof getCurrentUrls !== 'function') {
    throw new Error('Data connection not initialized');
  }

  return getCurrentUrls();
}
